const Admin = () => import('@/components/Admin/Admin');

const VimeoTest = () =>import ('@/components/Sample/VimeoTest');
// import Admin from '@/components/Admin/Admin'
//children
// import AdminDashboard from '@/components/Admin/AdminDashboard'
const MasterConfiguration = () => import('@/components/Admin/MasterConfiguration');
const HomePage = () => import('@/components/Admin/MasterConfiguration/HomePage');
const TimeFormat = () => import('@/components/Admin/MasterConfiguration/TimeFormat');
const Timezones = () => import('@/components/Admin/MasterConfiguration/Timezone');
const DateFormat = () => import('@/components/Admin/MasterConfiguration/DateFormat');
const Currency = () => import('@/components/Admin/MasterConfiguration/Currency');
// import MasterConfiguration from '@/components/Admin/MasterConfiguration'
// import HomePage from '@/components/Admin/MasterConfiguration/HomePage'
// import TimeFormat from '@/components/Admin/MasterConfiguration/TimeFormat'
// import Timezone from '@/components/Admin/MasterConfiguration/Timezone'
// import DateFormat from '@/components/Admin/MasterConfiguration/DateFormat'
// import Currency from '@/components/Admin/MasterConfiguration/Currency'

const Conference = () => import('@/components/Admin/MasterConfiguration/Conference');
const SignUp = () => import('@/components/Admin/MasterConfiguration/SignUp');
const VisibleUserFormat = () => import('@/components/Admin/MasterConfiguration/VisibleUserFormat');
const CertificateStyle = () => import('@/components/Admin/MasterConfiguration/CertificateStyle');
const CertificateBackground = () => import('@/components/Admin/MasterConfiguration/CertificateBackground');
const CertificateField = () => import('@/components/Admin/MasterConfiguration/CertificateField');
// import Conference from '@/components/Admin/MasterConfiguration/Conference'
// import SignUp from '@/components/Admin/MasterConfiguration/SignUp'
// import VisibleUserFormat from '@/components/Admin/MasterConfiguration/VisibleUserFormat'
// import CertificateStyle from '@/components/Admin/MasterConfiguration/CertificateStyle'
// import CertificateBackground from '@/components/Admin/MasterConfiguration/CertificateBackground'
// import CertificateField from '@/components/Admin/MasterConfiguration/CertificateField'

const GamificationType = () => import('@/components/Admin/MasterConfiguration/GamificationType');
const GamificationBadgeGroup = () => import('@/components/Admin/MasterConfiguration/GamificationBadgeGroup');
const GamificationUnit = () => import('@/components/Admin/MasterConfiguration/GamificationUnit');
const PaymentGateway = () => import('@/components/Admin/MasterConfiguration/PaymentGateway');
const SubscriptionType = () => import('@/components/Admin/MasterConfiguration/SubscriptionType');
const UserType = () => import('@/components/Admin/MasterConfiguration/UserType');
// import GamificationType from '@/components/Admin/MasterConfiguration/GamificationType'
// import GamificationBadgeGroup from '@/components/Admin/MasterConfiguration/GamificationBadgeGroup'
// import GamificationUnit from '@/components/Admin/MasterConfiguration/GamificationUnit'
// import PaymentGateway from '@/components/Admin/MasterConfiguration/PaymentGateway'
// import SubscriptionType from '@/components/Admin/MasterConfiguration/SubscriptionType'
// import UserType  from '@/components/Admin/MasterConfiguration/UserType'

const Department = () => import('@/components/Admin/MasterConfiguration/Department');
const ProgramType = () => import('@/components/Admin/MasterConfiguration/ProgramType');
const Program = () => import('@/components/Admin/MasterConfiguration/Program');
const Standard = () => import('@/components/Admin/MasterConfiguration/Standard');
const Division = () => import('@/components/Admin/MasterConfiguration/Division');
const Gender = () => import('@/components/Admin/MasterConfiguration/Gender');
// import Department from '@/components/Admin/MasterConfiguration/Department'
// import ProgramType from '@/components/Admin/MasterConfiguration/ProgramType'
// import Program from '@/components/Admin/MasterConfiguration/Program'
// import Standard from '@/components/Admin/MasterConfiguration/Standard'
// import Division from '@/components/Admin/MasterConfiguration/Division'
// import Gender from '@/components/Admin/MasterConfiguration/Gender'

const Language = () => import('@/components/Admin/MasterConfiguration/Language');
const Social = () => import('@/components/Admin/MasterConfiguration/Social');
const CourseCompletionRule = () => import('@/components/Admin/MasterConfiguration/CourseCompletionRule');
const CourseScoreRule = () => import('@/components/Admin/MasterConfiguration/CourseScoreRule');
const ContentCompletionRule = () => import('@/components/Admin/MasterConfiguration/ContentCompletionRule');
const FileUploadStatus = () => import('@/components/Admin/MasterConfiguration/FileUploadStatus');
// import Language from '@/components/Admin/MasterConfiguration/Language'
// import Social from '@/components/Admin/MasterConfiguration/Social'
// import CourseCompletionRule from '@/components/Admin/MasterConfiguration/CourseCompletionRule'
// import CourseScoreRule from '@/components/Admin/MasterConfiguration/CourseScoreRule'
// import ContentCompletionRule from '@/components/Admin/MasterConfiguration/ContentCompletionRule'
// import FileUploadStatus from '@/components/Admin/MasterConfiguration/FileUploadStatus'

const CourseFileCategory = () => import('@/components/Admin/MasterConfiguration/CourseFileCategory');
const CourseInformation = () => import('@/components/Admin/CourseInformation');
const ChangeCourseInfo = () => import('@/components/Admin/ChangeCourseInfo');
const CourseConductType = () => import('@/components/Admin/MasterConfiguration/CourseConductType');
const DifficultyLevel = () => import('@/components/Admin/MasterConfiguration/DifficultyLevel');
const QuizType = () => import('@/components/Admin/MasterConfiguration/QuizType');
const Skill = () => import('@/components/Admin/MasterConfiguration/Skill');
const SkillCategory = () => import('@/components/Admin/MasterConfiguration/SkillCategory');
// import CourseFileCategory from '@/components/Admin/MasterConfiguration/CourseFileCategory'
// import CourseConductType from '@/components/Admin/MasterConfiguration/CourseConductType'
// import DifficultyLevel from '@/components/Admin/MasterConfiguration/DifficultyLevel'
// import QuizType from '@/components/Admin/MasterConfiguration/QuizType'
// import Skill from '@/components/Admin/MasterConfiguration/Skill'
// import SkillCategory from '@/components/Admin/MasterConfiguration/SkillCategory'

const AssignmentType = () => import('@/components/Admin/MasterConfiguration/AssignmentType');
const Communicationmode = () => import('@/components/Admin/MasterConfiguration/Communicationmode');
const Event = () => import('@/components/Admin/MasterConfiguration/Event');
const NotificationFrom = () => import('@/components/Admin/MasterConfiguration/NotificationFrom');
const VolpConfiguration = () => import('@/components/Admin/MasterConfiguration/VolpConfiguration');
const FileType = () => import('@/components/Admin/MasterConfiguration/FileType');
// import AssignmentType from '@/components/Admin/MasterConfiguration/AssignmentType'
// import Communicationmode from '@/components/Admin/MasterConfiguration/Communicationmode'
// import Event from '@/components/Admin/MasterConfiguration/Event'
// import NotificationFrom from '@/components/Admin/MasterConfiguration/NotificationFrom'
// import VolpConfiguration from '@/components/Admin/MasterConfiguration/VolpConfiguration'
// import FileType from '@/components/Admin/MasterConfiguration/FileType'

const FileFormat = () => import('@/components/Admin/MasterConfiguration/FileFormat');
const LinkPosition = () => import('@/components/Admin/MasterConfiguration/LinkPosition');
const CourseCategory = () => import('@/components/Admin/CourseCategory');
const Home = () => import('@/components/Admin/EventEngine/Home');
const NotificationHome = () => import('@/components/Admin/EventEngine/NotificationHome');
const NotificationHistory = () => import('@/components/Admin/EventEngine/NotificationHistory');
const PendingNotification = () => import('@/components/Admin/EventEngine/PendingNotifications');
// import FileFormat from '@/components/Admin/MasterConfiguration/FileFormat'
// import CourseCategory from '@/components/Admin/CourseCategory'
// import Home from '@/components/Admin/EventEngine/Home'
// import NotificationHome from '@/components/Admin/EventEngine/NotificationHome'
// import NotificationHistory from '@/components/Admin/EventEngine/NotificationHistory'
// import PendingNotification from '@/components/Admin/EventEngine/PendingNotifications'

//ends
//settings
const HomeSetting = () => import('@/components/Admin/Account&Settings/Home');
const BasicSettings = () => import('@/components/Admin/Account&Settings/BasicSettings');
const Users = () => import('@/components/Admin/Account&Settings/Users');
const Certification = () => import('@/components/Admin/Account&Settings/Certifications');
const Domain = () => import('@/components/Admin/Account&Settings/Domain');
const ECommerce = () => import('@/components/Admin/Account&Settings/ECommerce');
const Gamification = () => import('@/components/Admin/Account&Settings/Gamifications');
const Subscription = () => import('@/components/Admin/Account&Settings/Subscription');
const Features = () => import('@/components/Admin/Account&Settings/Features');
// import HomeSetting from '@/components/Admin/Account&Settings/Home'
// import BasicSettings from '@/components/Admin/Account&Settings/BasicSettings'
// import Users from '@/components/Admin/Account&Settings/Users'
// import Certification from '@/components/Admin/Account&Settings/Certifications'
// import Domain from '@/components/Admin/Account&Settings/Domain'
// import ECommerce from '@/components/Admin/Account&Settings/ECommerce'
// import Gamification from '@/components/Admin/Account&Settings/Gamifications'
// import Subscription from '@/components/Admin/Account&Settings/Subscription'
//ends

//Admin user
const UserHome = () => import('@/components/Admin/Users/Home');
const ResetPassword = () => import('@/components/Admin/Users/ResetPassword');
const AddUser = () => import('@/components/Admin/Users/AddUser');
const GetLearner = () => import('@/components/Admin/Users/GetLearner');
const GetInstructor = () => import('@/components/Admin/Users/GetInstructor');
const PromoteLearnerYear = () => import('@/components/Admin/Users/PromoteLearnerYear');
const SearchUser = () => import('@/components/Admin/Users/SearchUser');
const EditUser = () => import('@/components/Admin/Users/EditUser');
const BypassLogin = () => import('@/components/Admin/Users/BypassLogin');
// import UserHome from '@/components/Admin/Users/Home'
// import ResetPassword from '@/components/Admin/Users/ResetPassword'
// import AddUser from '@/components/Admin/Users/AddUser'
// import GetLearner from '@/components/Admin/Users/GetLearner'
// import GetInstructor from '@/components/Admin/Users/GetInstructor'
// import PromoteLearnerYear from '@/components/Admin/Users/PromoteLearnerYear'
// import SearchUser from '@/components/Admin/Users/SearchUser'
// import EditUser from '@/components/Admin/Users/EditUser'
//ends

//Import Export
const ImportExportHome = () => import('@/components/Admin/ImportExport/Home');
const ImportInstructor = () => import('@/components/Admin/ImportExport/InstructorImport');
const ImportLearner = () => import('@/components/Admin/ImportExport/LearnerImport');
const BulkSubjectRegistration = () => import('@/components/Admin/ImportExport/BulkSubjectRegistration');
const BulkBlockUnblockUser = () => import('@/components/Admin/ImportExport/BulkBlockUnblockUser');
// import ImportExportHome from '@/components/Admin/ImportExport/Home'
// import ImportInstructor from '@/components/Admin/ImportExport/InstructorImport'
// import ImportLearner from '@/components/Admin/ImportExport/LearnerImport'
// import BulkSubjectRegistration from '@/components/Admin/ImportExport/BulkSubjectRegistration'
//ends
//test
const AdminTest = () => import('@/components/Learner/Certificate');
//import AdminTest from '@/components/Learner/Certificate'
const HelpDesk = () => import('@/components/Admin/HelpDesk');
const PaymentHistory = () => import('@/components/Admin/PaymentHistory');
const Coursereport = () => import('@/components/Admin/CourseReport/Coursereport');
const CourseFees = () => import('@/components/Admin/CourseFees')
const Collaborate = () => import('@/components/Admin/Collaborate')

const routes = [
  //test
  {
    path: '/vimeo-test',
    name: 'vimeo-test',
    component: VimeoTest,
  },
  {
    path: '/admin-test',
    name: 'admin-test',
    component: AdminTest,
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    props: true,
    meta:{breadcrumb: 'Dashboard'},
    children: [
      {
        path: '/admin-master-configuration',
        name: 'admin-master-configuration',
        component: MasterConfiguration,
        meta:{breadcrumb: 'Master'},
        children: [
          {
            path: '/admin-master-home-page',
            name: 'admin-master-home-page',
            component: HomePage,
            meta:{breadcrumb: 'Home-Page'}
          },
          {
            path: '/admin-master-time-format',
            name: 'admin-master-time-format',
            component: TimeFormat,
            meta:{breadcrumb: 'Time-Format'}
          },
          {
            path: '/admin-master-time-zone',
            name: 'admin-master-time-zone',
            component: Timezones,
            meta:{breadcrumb: 'Time-Zone'}
          },
          {
            path: '/admin-master-dateformat',
            name: 'admin-master-dateformat',
            component: DateFormat,
            meta:{breadcrumb: 'dateformat'}
          },
          {
            path: '/admin-master-Currency',
            name: 'admin-master-Currency',
            component: Currency,
            meta:{breadcrumb: 'Currency'}
          },
          {
            path: '/admin-master-Conference',
            name: 'admin-master-Conference',
            component: Conference,
            meta:{breadcrumb: 'Conference'}
          },
          {
            path: '/admin-master-Sign-Up',
            name: 'admin-master-Sign-Up',
            component: SignUp,
            meta:{breadcrumb: 'SignUp'}
          },
          {
            path: '/admin-master-visible-user-format',
            name: 'admin-master-visible-user-format',
            component: VisibleUserFormat,
            meta:{breadcrumb: 'Visible-User-Format'}
          },
          {
            path: '/admin-master-certificate-style',
            name: 'admin-master-certificate-style',
            component: CertificateStyle,
            meta:{breadcrumb: 'Certificate-Style'}
          },
          {
            path: '/admin-master-certificate-background',
            name: 'admin-master-certificate-background',
            component: CertificateBackground,
            meta:{breadcrumb: 'Certificate-Background'}
          },
          {
            path: '/admin-master-certificate-field',
            name: 'admin-master-certificate-field',
            component: CertificateField,
            meta:{breadcrumb: 'Certificate-Field'}
          },
          {
            path: '/admin-master-gamification-type',
            name: 'admin-master-gamification-type',
            component: GamificationType,
            meta:{breadcrumb: 'GamificationType'}
          },
          {
            path: '/admin-master-gamification-badge-group',
            name: 'admin-master-gamification-badge-group',
            component: GamificationBadgeGroup,
            meta:{breadcrumb: 'Gamification-Badge-Group'}
          },
          {
            path: '/admin-master-gamification-unit',
            name: 'admin-master-gamification-unit',
            component: GamificationUnit,
            meta:{breadcrumb: 'Gamification-Unit'}
          },
          {
            path: '/admin-master-payment-gateway',
            name: 'admin-master-payment-gateway',
            component: PaymentGateway,
            meta:{breadcrumb: 'Payment-gateway'}
          },
          {
            path: '/admin-master-subscription-type',
            name: 'admin-master-subscription-type',
            component: SubscriptionType,
            meta:{breadcrumb: 'Subscription-Type'}
          },
          {
            path: '/admin-master-user-type',
            name: 'admin-master-user-type',
            component: UserType,
            meta:{breadcrumb: 'User-Type'}
          },
          {
            path: '/admin-master-department',
            name: 'admin-master-department',
            component: Department,
            meta:{breadcrumb: 'Department'}
          },
          {
            path: '/admin-master-program-type',
            name: 'admin-master-program-type',
            component: ProgramType,
            meta:{breadcrumb: 'Program-Type'}
          },
          {
            path: '/admin-master-program',
            name: 'admin-master-program',
            component: Program,
            meta:{breadcrumb: 'Program'}
          },
          {
            path: '/admin-master-standard',
            name: 'admin-master-standard',
            component: Standard,
            meta:{breadcrumb: 'Standard'}
          },
          {
            path: '/admin-master-division',
            name: 'admin-master-division',
            component: Division,
            meta:{breadcrumb: 'Division'}
          },
          {
            path: '/admin-master-gender',
            name: 'admin-master-gender',
            component: Gender,
            meta:{breadcrumb: 'gender'}
          },
          {
            path: '/admin-master-language',
            name: 'admin-master-language',
            component: Language,
            meta:{breadcrumb: 'language'}
          },
          {
            path: '/admin-master-social',
            name: 'admin-master-social',
            component: Social,
            meta:{breadcrumb: 'social'}
          },
          {
            path: '/admin-master-course-completion-rule',
            name: 'admin-master-course-completion-rule',
            component: CourseCompletionRule,
            meta:{breadcrumb: 'Course-Completion-Rule'}
          },
          {
            path: '/admin-master-course-score-rule',
            name: 'admin-master-course-score-rule',
            component: CourseScoreRule,
            meta:{breadcrumb: 'Course-Score-Rule'}
          },
          {
            path: '/admin-master-content-completion-rule',
            name: 'admin-master-content-completion-rule',
            component: ContentCompletionRule,
            meta:{breadcrumb: 'Content-Completion-Rule'}
          },
          {
            path: '/admin-master-file-upload-status',
            name: 'admin-master-file-upload-status',
            component: FileUploadStatus,
            meta:{breadcrumb: 'File-Upload-Status'}
          },
          {
            path: '/admin-master-course-file-category',
            name: 'admin-master-course-file-category',
            component: CourseFileCategory ,
            meta:{breadcrumb: 'Course-File-Category'}
          },
          {
            path: '/admin-master-course-conduct-type',
            name: 'admin-master-course-conduct-type',
            component: CourseConductType ,
            meta:{breadcrumb: 'Course-Conduct-Type'}
          },
          {
            path: '/admin-master-difficulty-level',
            name: 'admin-master-difficulty-level',
            component: DifficultyLevel ,
            meta:{breadcrumb: 'Difficulty-Level'}
          },
          {
            path: '/admin-master-quiz-type',
            name: 'admin-master-quiz-type',
            component: QuizType ,
            meta:{breadcrumb: 'Quiz-Type'}
          },
          {
            path: '/admin-master-skill',
            name: 'admin-master-skill',
            component: Skill ,
            meta:{breadcrumb: 'Skill'}
          },
          {
            path: '/admin-master-skillCategory',
            name: 'admin-master-skillCategory',
            component: SkillCategory ,
            meta:{breadcrumb: 'SkillCategory'}
          },

          {
            path: '/admin-master-assignment-type',
            name: 'admin-master-assignment-type',
            component: AssignmentType ,
            meta:{breadcrumb: 'Assignment-Type'}
          },
          {
            path: '/admin-master-communication-mode',
            name: 'admin-master-communication-mode',
            component: Communicationmode  ,
            meta:{breadcrumb: 'Communication-Mode'}
          },
          {
            path: '/admin-master-event',
            name: 'admin-master-event',
            component: Event  ,
            meta:{breadcrumb: 'Event'}
          },
          {
            path: '/admin-master-notification-from',
            name: 'admin-master-notification-from',
            component: NotificationFrom  ,
            meta:{breadcrumb: 'Notification-From'}
          },
          {
            path: '/admin-master-volp-configuration',
            name: 'admin-master-volp-configuration',
            component: VolpConfiguration  ,
            meta:{breadcrumb: 'Volp-Configuration'}
          },
          {
            path: '/admin-master-file-type',
            name: 'admin-master-file-type',
            component: FileType,
            meta:{breadcrumb: 'File-Type'}
          },
          {
            path: '/admin-master-file-format',
            name: 'admin-master-file-format',
            component: FileFormat  ,
            meta:{breadcrumb: 'File-Format'}
          },
          {
            path: '/admin-master-link-position',
            name: 'admin-master-link-position',
            component: LinkPosition  ,
            meta:{breadcrumb: 'Link-Position'}
          },

        ]
      },
      {
        path: '/admin-course-categories',
        name: 'admin-course-categories',
        component: CourseCategory,
        meta:{breadcrumb: 'Course Categories'},
      },
      {
        path: '/admin-course-info',
        name: 'admin-course-info',
        component: CourseInformation,
        meta:{breadcrumb: 'Course Information'},
      },  
      {
        path: '/admin-change-course-info',
        name: 'admin-change-course-info',
        component: ChangeCourseInfo,
        meta:{breadcrumb: 'Change Course Information'},
      },
      {
        path: '/admin-course-report',
        name: 'admin-course-report',
        component: Coursereport,
        meta:{breadcrumb: 'Course Report'},
      },
      {
        path: '/admin-course-fees',
        name: 'admin-course-fees',
        component: CourseFees,
        meta:{breadcrumb: 'Set Course Fees'},
      },
      {
        path: '/admin-add-collaborate',
        name: 'admin-add-collaborate',
        component: Collaborate,
        meta:{breadcrumb: 'Add Collaborator'},
      }, 
      {
        path: '/admin-event-engine',
        name: 'admin-event-engine',
        component: Home,
        meta:{breadcrumb: 'Event Engine'},
        children: [
          {
            path: '/notification-events',
            name: 'notification-events',
            component: NotificationHome,
            meta:{breadcrumb: 'Notification Events'},
          },
          {
            path: '/notification-history',
            name: 'notification-history',
            component: NotificationHistory,
            meta:{breadcrumb: 'Notification History'},
          },
          {
            path: '/pending-notfication',
            name: 'pending-notfication',
            component: PendingNotification,
            meta:{breadcrumb: 'Pending Notifications'},
          },
        ]
      },
      {
        path: '/admin-home-settings',
        name: 'admin-home-settings',
        component: HomeSetting,
        meta:{breadcrumb: 'Accounts & Settings'},
        children: [
          {
            path: '/admin-basic-settings',
            name: 'admin-basic-settings',
            component: BasicSettings,
            meta:{breadcrumb: 'Basic-Settings'},            
          },
          {
            path: '/admin-users-settings',
            name: 'admin-users-settings',
            component: Users,
            meta:{breadcrumb: 'Users-Setting'},            
          },  
          {
            path: '/admin-certification-settings',
            name: 'admin-certification-settings',
            component: Certification,
            meta:{breadcrumb: 'Certification-Setting'},            
          },
          {
            path: '/admin-domain-settings',
            name: 'admin-domain-settings',
            component: Domain,
            meta:{breadcrumb: 'Domain-Setting'},            
          },
          {
            path: '/admin-ecommerce-settings',
            name: 'admin-ecommerce-settings',
            component: ECommerce,
            meta:{breadcrumb: 'ECommerce-Setting'},            
          },
          {
            path: '/admin-gamification-settings',
            name: 'admin-gamification-settings',
            component: Gamification,
            meta:{breadcrumb: 'Gamification-Setting'},            
          },
          {
            path: '/admin-subscription-settings',
            name: 'admin-subscription-settings',
            component: Subscription,
            meta:{breadcrumb: 'Subscription-Setting'},            
          },
          {
            path: '/admin-features-settings',
            name: 'admin-features-settings',
            component: Features,
            meta:{breadcrumb: 'Features-Setting'},            
          },    
        ]
      },
      {
        path: '/admin-users',
        name: 'admin-users',
        component: UserHome,
        meta:{breadcrumb: 'Users'},
        children: [
          {
            path: '/admin-reset-password',
            name: 'admin-reset-password',
            component: ResetPassword,
            meta:{breadcrumb: 'Reset Password'},            
          },   
          {
            path: '/admin-add-users',
            name: 'admin-add-users',
            component: AddUser,
            meta:{breadcrumb: 'Add User'},            
          },
          {
            path: '/admin-get-learner',
            name: 'admin-get-learner',
            component: GetLearner,
            meta:{breadcrumb: 'Get Learner'},            
          },
          {
            path: '/admin-get-instructor',
            name: 'admin-get-instructor',
            component: GetInstructor,
            meta:{breadcrumb: 'Get Instructor'},            
          },
          {
            path: '/admin-promote-learner-year',
            name: 'admin-promote-learner-year',
            component: PromoteLearnerYear,
            meta:{breadcrumb: 'Promote Learner to next Year'},            
          },
          {
            path: '/admin-bypass-login',
            name: 'admin-bypass-login',
            component: BypassLogin,
            meta:{breadcrumb: 'Bypass Login'},            
          },
          {
            path: '/admin-search-user',
            name: 'admin-search-user',
            component: SearchUser,
            meta:{breadcrumb: 'Search & Edit User'},  
          },
          {
            path: '/admin-search-edit-user',
            name: 'admin-search-edit-user',
            component: EditUser,
            meta:{breadcrumb: 'Edit User'},  
          },
        ]
      },
      {
        path: '/admin-import-export',
        name: 'admin-import-export',
        component: ImportExportHome,
        meta:{breadcrumb: 'Import-Export'},
        children: [
          {
            path: '/admin-import-instructor',
            name: 'admin-import-instructor',
            component: ImportInstructor,
            meta:{breadcrumb: 'Import Instructor'},            
          },
          {
            path: '/admin-import-learner',
            name: 'admin-import-learner',
            component: ImportLearner,
            meta:{breadcrumb: 'Import Learner'},            
          },
          {
            path: '/admin-bulk-subject-registration',
            name: 'admin-bulk-subject-registration',
            component: BulkSubjectRegistration,
            meta:{breadcrumb: 'Bulk Subject Registration'},            
          },  
          {
            path: '/admin-bulk-block-unblock-user',
            name: 'admin-bulk-block-unblock-user',
            component: BulkBlockUnblockUser,
            meta:{breadcrumb: 'Bulk Block/Unblock User'},            
          },                   
        ]
      }, 
      {
        path: '/admin-help-desk',
        name: 'admin-help-desk',
        component: HelpDesk,
        meta:{breadcrumb: 'Help Desk'},
      },
      {
        path: '/payment-transaction-history',
        name: 'payment-transaction-history',
        component: PaymentHistory,
        meta:{breadcrumb: 'Payment Transaction History'},
      },
    ]  
}
 
]

export default routes